import createVuePlugin from './helpers/createVuePlugin';
import CpSearchLocator from './components/CpSearchLocator.vue';

export default createVuePlugin({
    version: '0.0.1',

    defaults: {
        icon: {
            active: {
                path: 'M29.3211 7.7282C26.54 3.00159 21.6004 0.113925 16.1073 0.00356981C15.8729 -0.00118994 15.6369 -0.00118994 15.4023 0.00356981C9.90933 0.113925 4.96967 3.00159 2.18857 7.7282C-0.654115 12.5595 -0.73189 18.3629 1.98048 23.2523L13.3436 43.7357C13.3487 43.7448 13.3538 43.7538 13.3591 43.7628C13.859 44.6186 14.7547 45.1295 15.755 45.1295C16.7552 45.1295 17.6509 44.6185 18.1507 43.7628C18.156 43.7538 18.1611 43.7448 18.1662 43.7357L29.5293 23.2523C32.2415 18.3629 32.1637 12.5595 29.3211 7.7282V7.7282ZM15.7548 20.4493C12.2016 20.4493 9.31085 17.6024 9.31085 14.103C9.31085 10.6036 12.2016 7.75667 15.7548 7.75667C19.308 7.75667 22.1988 10.6036 22.1988 14.103C22.1988 17.6024 19.3081 20.4493 15.7548 20.4493Z',
                fillColor: '#1D1D1B',
                fillOpacity: 1,
                strokeColor: '',
                strokeWeight: 0,
            },
            inactive: {
                path: 'M29.3211 7.7282C26.54 3.00159 21.6004 0.113925 16.1073 0.00356981C15.8729 -0.00118994 15.6369 -0.00118994 15.4023 0.00356981C9.90933 0.113925 4.96967 3.00159 2.18857 7.7282C-0.654115 12.5595 -0.73189 18.3629 1.98048 23.2523L13.3436 43.7357C13.3487 43.7448 13.3538 43.7538 13.3591 43.7628C13.859 44.6186 14.7547 45.1295 15.755 45.1295C16.7552 45.1295 17.6509 44.6185 18.1507 43.7628C18.156 43.7538 18.1611 43.7448 18.1662 43.7357L29.5293 23.2523C32.2415 18.3629 32.1637 12.5595 29.3211 7.7282V7.7282ZM15.7548 20.4493C12.2016 20.4493 9.31085 17.6024 9.31085 14.103C9.31085 10.6036 12.2016 7.75667 15.7548 7.75667C19.308 7.75667 22.1988 10.6036 22.1988 14.103C22.1988 17.6024 19.3081 20.4493 15.7548 20.4493Z',
                fillColor: '#1D1D1B',
                fillOpacity: 1,
                strokeColor: '',
                strokeWeight: 0,
            },
        },
        key: null,
        options: {},
    },

    install(Vue, options) {
        Vue.prototype.$searchlocator = options;

        const components = { CpSearchLocator };
        Object.entries(components).forEach(([key, value]) => {
            Vue.component(key, value);
        });

        // @note - Card template
        // Vue.component('cp-card', {
        //     props: {
        //         store: {
        //             type: Object,
        //         },
        //     },
        //     template: Vue.prototype.config.formatCard ? Vue.prototype.config.formatCard() : Vue.prototype.config.templates.card,
        // });
        //
        // if (Vue.prototype.config.installComponents) {
        //     Vue.component('cp-store-locator', StoreLocator);
        // }
    },
});
